import ServiceContainer from './ServiceContainer';

export default ServiceContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/Service/index.js